import React from 'react';
import { useAITTheme } from '../ui/theme';

const AirTicketPackage: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M19.2188 0H5.13153C4.92432 0 4.72565 0.0822449 4.57901 0.228882L0.228729 4.57916C0.0888062 4.71909 0 4.91943 0 5.13168V19.2188C0 19.6503 0.349731 20 0.78125 20H14.8685C15.0752 20 15.2742 19.9168 15.4193 19.7726C15.4198 19.772 15.4204 19.7717 15.421 19.7711L19.7713 15.4208C19.9178 15.2744 20 15.0757 20 14.8685V0.781403C20 0.357666 19.6558 0 19.2188 0ZM14.5448 4.35028C13.8039 4.35028 10.2597 4.35028 9.711 4.35028L12.4988 1.5625H17.3326L14.5448 4.35028ZM6.17188 5.91278H9.47784V9.21875H6.17188V5.91278ZM5.45517 1.5625H10.289L7.50122 4.35028C6.47675 4.35028 3.66425 4.35028 2.66739 4.35028L5.45517 1.5625ZM14.0872 18.4375H1.5625V5.91278H4.60938V10C4.60938 10.4315 4.95911 10.7812 5.39062 10.7812H10.2591C10.6906 10.7812 11.0403 10.4315 11.0403 10V5.91278H14.0872V18.4375ZM15.6497 17.3326V5.45517L18.4375 2.66739V14.5448L15.6497 17.3326Z"
      />
    </svg>
  );
};

export default AirTicketPackage;
